import { useQuery } from "@tanstack/react-query";
import { api, unwrap } from "@/lib/api";

export interface WorkerImageVersions {
	/** Stable semver tags, newest first. */
	versions: string[];
	/** What `latest` currently resolves to, when the registry will say. */
	latest: string | null;
	/** The tag this manager deploys by default. */
	configuredTag: string;
	error?: string;
}

/**
 * Versions available to deploy.
 *
 * Used to label the default honestly — "latest (1.3.2)" rather than just
 * "latest", so an operator can see and later pin what they ran.
 */
export function useWorkerImages() {
	return useQuery({
		queryKey: ["worker-images"],
		queryFn: async (): Promise<WorkerImageVersions> => {
			const data = (await unwrap(
				api.api.workers.images.get(),
			)) as WorkerImageVersions;
			return data;
		},
		// Registry tags change rarely; avoid a lookup on every wizard open.
		staleTime: 5 * 60_000,
	});
}
